function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { LANG } from '../../utils/constant';
import { translateFieldName, translate, assetPath } from '../../utils/helpers';
import CertificationsMetaTags from '../meta-tags/CertificationsMetaTags';
import { Services } from '../../utils/Services';

var CertificationsPage = /*#__PURE__*/function (_Component) {
  _inherits(CertificationsPage, _Component);

  var _super = _createSuper(CertificationsPage);

  function CertificationsPage(props) {
    var _this;

    _classCallCheck(this, CertificationsPage);

    _this = _super.call(this, props);
    _this.state = {
      certifications: []
    };
    return _this;
  }

  _createClass(CertificationsPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Services.fetchCertifications().then(function (certifications) {
        return _this2.setState({
          certifications: certifications
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var certifications = this.state.certifications;
      return /*#__PURE__*/React.createElement("div", {
        className: "container certifications-page mobile-center"
      }, /*#__PURE__*/React.createElement(CertificationsMetaTags, null), /*#__PURE__*/React.createElement("h2", {
        className: "certifications-page-title mobile-center main-bg-after"
      }, translate('All certifications', 'Toutes les certifications')), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, certifications.map(function (certification) {
        return certification[translateFieldName('name')] ? /*#__PURE__*/React.createElement("div", {
          key: certification.id,
          className: " certifications-box col-lg-3 col-md-4 col-sm-6 col-6 main-box-hover"
        }, /*#__PURE__*/React.createElement("a", {
          href: "/".concat(LANG, "/shop/#/certifications/").concat(certification.id),
          className: "logo"
        }, /*#__PURE__*/React.createElement("div", {
          className: "logo-box"
        }, certification[translateFieldName('logo')].url !== null ? /*#__PURE__*/React.createElement("img", {
          alt: certification[translateFieldName('name')],
          className: "cover-image",
          src: assetPath(certification[translateFieldName('logo')].url)
        }) : null), /*#__PURE__*/React.createElement("div", {
          className: "certification-name main-txt-test"
        }, certification[translateFieldName('name')]))) : null;
      })));
    }
  }]);

  return CertificationsPage;
}(Component);

export default CertificationsPage;